// Card select and scroll handler
document.addEventListener("DOMContentLoaded", function() {
  if (typeof jQuery === 'undefined') {
    return;
  }

  // Function to normalize price formatting (remove spaces between $ and number)
  function normalizePrice(priceText) {
    if (!priceText) return priceText;
    // Remove spaces between $ and numbers, normalize to $XX.XX format
    return priceText.replace(/\$\s+/g, '$').replace(/\s+\$/g, '$').trim();
  }

  // Normalize all existing prices on page load
  jQuery('.price_main_regular').each(function() {
    const currentText = jQuery(this).text();
    const normalized = normalizePrice(currentText);
    if (currentText !== normalized) {
      jQuery(this).text(normalized);
    }
  });

  jQuery(".form-select.card-select").on("change", function() {
    const geturrentSelect = jQuery(this).val();
    const cardBody = jQuery(this).closest(".card-body");
    const currentElementVariant = cardBody.find(".quick-add .product-variant-id");
    const parent_price_item = cardBody.find(".quick-add button .price_main_regular");
    
    if (currentElementVariant.length && parent_price_item.length) {
      cardBody.find(".product_variants option").each(function() {
        if (jQuery(this).val() == geturrentSelect) {
          var getVariant = jQuery(this).attr("data-value");
          var getVariantPrice = jQuery(this).attr("data-variant_price");
          if (getVariant && getVariantPrice) {
            currentElementVariant.attr("value", getVariant);
            const normalizedPrice = normalizePrice(getVariantPrice);
            parent_price_item.html(normalizedPrice);
          }
        }
      });
    }
  });
  
  jQuery(window).scroll(function(event) {
    var scroll = jQuery(window).scrollTop();
    var founderSection = jQuery('[data-section="meet-our-founder"]');
    if (founderSection.length) {
      jQuery('body').toggleClass('ok',
        //add 'ok' class when div position match or exceeds else remove the 'ok' class.
        scroll >= founderSection.offset().top
      );
    }
  });
  //trigger the scroll
  jQuery(window).scroll(); //ensure if you're in current position when page is refreshed
});

